module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-36x36-096625897504ebb02e59106bed33f3dc.png";